import '~/js/modules/section-hero';
import RoomAccommodations from '~/js/components/accommodations/LevelFilterMainPanel';

const { resortData: resortList = [], categoryLevel = '' } = window.beaches_app.page;

ReactDOM.render(
  <RoomAccommodations
    level={ categoryLevel }
    resortList={ resortList }
  />,
  document.querySelector('#root')
);

